import { SortableWidgetProps, Widget } from '@creditsights/styleguide-web';
import classNames from 'classnames/bind';
import { forwardRef, ReactElement } from 'react';
import { useNavigate } from 'react-router-dom';
import { ROUTES } from '../../../Base.constants';
import { useFeedFilters } from '../../../hooks/common';
import useFetchSnippets from '../../../hooks/snippets/useFetchSnippets';
import { SnippetType } from '../../../models';
import { getArticleMouseClickHandler } from '../../../utils/articleUtils';
import styles from './CSQuickLinks.module.scss';

const cx = classNames.bind(styles);

const CSQuickLinks = (props: SortableWidgetProps, ref): ReactElement => {
  const { filters } = useFeedFilters();
  const {
    data: snippets,
    isLoading,
    isRefetching,
    isError,
    refetch,
  } = useFetchSnippets(SnippetType.QUICK_LINK, filters);
  const navigate = useNavigate();
  const mouseClickHandler = getArticleMouseClickHandler(({ id }) => navigate(ROUTES.article(id)), navigate);

  return (
    <Widget
      headerTitle="Quick Links"
      fixedHeight
      dataTestId="cs-quick-links"
      isLoading={isLoading || isRefetching}
      isError={isError}
      onRetryAfterErrorClick={refetch}
      ref={ref}
      {...props}
    >
      <div className={cx('body')} data-testid="cs-quick-links-content" onClick={mouseClickHandler}>
        {snippets?.length ? (
          snippets.map((snippet, index) => (
            <a
              // eslint-disable-next-line react/no-array-index-key
              key={`${snippet.linkTitle}_${index}`}
              className={cx('snippet-link')}
              href={snippet.link}
              data-testid="quick-link"
            >
              {snippet.linkTitle}
            </a>
          ))
        ) : (
          <div>No Quick Links</div>
        )}
      </div>
    </Widget>
  );
};

export default forwardRef(CSQuickLinks);
